import UISelect from 'UIComponents/input/UISelect';
import { EVENT } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { INPUT_WIDTHS, LABEL_WIDTHS } from '../../constants/inlineLayout';
import { useConditionInputs } from '../../hooks/useConditionInputs';
import { useEditorActions } from '../../hooks/useEditorActions';
import { MEDIA_SIZES, useElementSize } from '../../hooks/useElementSize';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useBehavioralEventFilter } from '../../hooks/useBehavioralEventFilter';
import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import UpdateFilterWithExternalOptionsNotification from '../operator/UpdateFilterWithExternalOptionsNotification';
import EditorConditionAsset from './EditorConditionAsset';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import EditorBehavioralEventRelatedConditionsGroup from './EditorBehavioralEventRelatedConditionsGroup';
//@ts-expect-error file not typed
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import emptyFunction from 'react-utils/emptyFunction';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorBehavioralEventRelatedConditionsGroupResponsive = props => {
  var _condition$field;
  const {
    condition,
    conditionPath
  } = props;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(EVENT, conditionPath, condition);
  const {
    statusCondition,
    refinementConditionsEmptyValue
  } = useBehavioralEventFilter(condition);

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = !!((_condition$field = condition.field) !== null && _condition$field !== void 0 && _condition$field.userHasNoAccess);
  const {
    canFilterBeConverted,
    disableOperatorSelection,
    handleUpdateClick,
    isOperatorIncompatible,
    onSelectedOptionChange,
    operatorOptions
  } = useConditionInputs({
    condition: statusCondition,
    disabled: userHasNoAccess,
    filterFamily: EVENT,
    onConditionOperatorChange: onFieldConditionOperatorChange,
    onConditionValueChange: emptyFunction
  });
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorBehavioralEventRelatedConditionsGroup, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: EVENT,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: LABEL_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: EVENT,
          onAssetChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS[width.size]
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-onboarding": "filter-condition-select-field",
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: disableOperatorSelection,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          readOnly: operatorOptions.length === 1,
          value: statusCondition.constructor.toString()
        })
      })]
    }), isOperatorIncompatible && /*#__PURE__*/_jsx(UpdateFilterWithExternalOptionsNotification, {
      onUpdateClick: handleUpdateClick,
      canFilterBeConverted: canFilterBeConverted
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: EVENT,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue,
      hasInlineLayout: true
    })]
  });
};
export default EditorBehavioralEventRelatedConditionsGroupResponsive;